import React, { useState, useEffect, useRef, useCallback } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { scooterEnumToNumStatuses } from "data/scooter-numeric-statuses";
import getLockIcon from "views/pages/bikes/helpers/get-lock-icon";
import getChargeIcon from "views/pages/bikes/helpers/get-charge-icon";
import getGpsIcon from "views/pages/bikes/helpers/get-gps-icon";
import getOnlineIcon from "views/pages/bikes/helpers/get-online-icon";
import { openCustomModal, closeCustomModal } from "views/lib/components/modals";
import { getList } from "actions/scooter/scooter/actions";
import { getList as getParkingList } from "actions/scooter/parking/actions";
import getScooterBatteryIcon from "helpers/scooter/get-scooter-battery-icon";
import getScooterProgressBar from "helpers/scooter/get-scooter-progress-bar";
import Filers from "../filters";
import { MapComponent } from "./googleMap";
import SingleInfo from "../single/info";
import { labelItems, pausedColor, stateColor } from "./map-filter-items";

const PAUSED_STATUS = 1000;
const TURNED_ON_STATUS = 2000;

const ScooterHotMap = ({
                         getList,
                         list,
                         getParkingList,
                         parkingList,
                         openCustomModal,
                         closeCustomModal
                       }) => {
  const [selected, setSelected] = useState(null);
  const [filters, setFilters] = useState([]);
  const [statusesFilters, setStatusesFilters] = useState([...labelItems.map(i => i.value), PAUSED_STATUS, TURNED_ON_STATUS]);

  const intervalIdRef = useRef(-1);

  const startListGetter = useCallback(() => {
      getList(0, 10000, undefined, filters);
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = setInterval(() => {
        getList(0, 10000, undefined, filters);
      }, 20 * 1000);
    },
    [getList, filters]);

  const handleSearch = (filters) => {
    setFilters(filters);
  };

  const handleReset = () => {
    setFilters({});
  };

  const updateStatusesFilters = (ev) => {
    const value = +ev.target.value;
    if (statusesFilters.includes(value)) {
      setStatusesFilters(statusesFilters.filter(i => i !== value));
    } else {
      setStatusesFilters([...statusesFilters, value]);
    }
  };

  const getInfoWrapper = () => (
    <div className="p-2">
      {`All: ${list.length}`}
      <hr className="mt-2 mb-2"/>
      {labelItems.map(labelItem => (
        <React.Fragment key={labelItem.value}>
          <div className="form-check d-flex align-items-center justify-content-between">
            <input className="form-check-input" type="checkbox" value={labelItem.value} onChange={updateStatusesFilters}
                   id={`status-filter-${labelItem.value}`} checked={statusesFilters.includes(labelItem.value)}/>
            <label className="form-check-label"
                   htmlFor={`status-filter-${labelItem.value}`}>{`${labelItem.label}: ${list.filter(item => scooterEnumToNumStatuses[item.status] === labelItem.value).length}`}</label>
            <div className="map-checkboxes-color" style={{ "--map-checkboxes-color": labelItem.color }}/>
          </div>
        </React.Fragment>
      ))}
      <div className="form-check d-flex align-items-center justify-content-between">
        <input className="form-check-input" type="checkbox" value={PAUSED_STATUS} onChange={updateStatusesFilters}
               id="status-filter-paused" checked={statusesFilters.includes(PAUSED_STATUS)}/>
        <label className="form-check-label"
               htmlFor="status-filter-paused">{`Paused: ${list.filter(item => scooterEnumToNumStatuses.RIDING === scooterEnumToNumStatuses[item.status] && item.locked).length}`}</label>
        <div className="map-checkboxes-color" style={{ "--map-checkboxes-color": pausedColor }}/>
      </div>
      <div className="form-check d-flex align-items-center justify-content-between">
        <input className="form-check-input" type="checkbox" value={TURNED_ON_STATUS} onChange={updateStatusesFilters}
               id="status-filter-state" checked={statusesFilters.includes(TURNED_ON_STATUS)}/>
        <label className="form-check-label"
               htmlFor="status-filter-state">{`Turned ${statusesFilters.includes(TURNED_ON_STATUS) ? 'ON' : 'OFF'}: ${list.filter(item => (item.state === 'ON' && statusesFilters.includes(TURNED_ON_STATUS)) || (item.state === 'OFF' && !statusesFilters.includes(TURNED_ON_STATUS))).length}`}</label>
        <div className="map-checkboxes-color" style={{ "--map-checkboxes-color": stateColor }}/>
      </div>
      <hr className="mt-1 mb-1"/>
      {`Locked: ${list.filter(item => item.locked).length}`}<br/>
      {`UNLocked: ${list.filter(item => !item.locked).length}`}<br/>
    </div>
  );

  const handleOpen = (value) => {
    // [original.located.longitude, original.located.latitude]
    const { located } = value;
    if (!located) {
      toast("Coordinates not available", {
        type: toast.TYPE.ERROR,
      });
      return null;
    }
    setSelected(value.id);

    const modalObj = {
      id: "bike-history-position",
      modalSettings: {
        size: "sm",
        style: {
          width: 400
        }
      },
      header: "Scooter Info",
      children: (
        <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
          <SingleInfo
            item={value}
            handleClick={() => closeCustomModal(modalObj)}
          />
        </React.Suspense>
      ),
      handleClose: () => closeCustomModal(modalObj)
    };
    openCustomModal(modalObj);
  };

  useEffect(() => {
    getParkingList();
  }, [getParkingList]);

  useEffect(() => {
    startListGetter();

    return () => {
      clearInterval(intervalIdRef.current);
    };
  }, [startListGetter]);

  const markersFiltered = list
  .filter(item => statusesFilters.includes(scooterEnumToNumStatuses[item.status]) || (scooterEnumToNumStatuses.RIDING === scooterEnumToNumStatuses[item.status] && item.locked))
  .filter(item => (statusesFilters.includes(TURNED_ON_STATUS) && item.state === 'ON') || (!statusesFilters.includes(TURNED_ON_STATUS) && item.state === 'OFF'));

  return (
    <div className="w-100 h-100 p-2 position-relative">
      <div className="filters">
        <Filers
          activeFilters={filters}
          totalCount={list.length}
          handleSearch={handleSearch}
          handleReset={handleReset}
        />
      </div>

      <div style={{
        height: "calc(100vh - 140px)"
      }}>
        <MapComponent
          center={{
            lat: 40.1870293,
            lng: 44.5129457
          }}
          zoom={12}
          markers={markersFiltered}
          parkings={parkingList}
          info={getInfoWrapper}
          progressBar={getScooterProgressBar}
          battery={getScooterBatteryIcon}
          onCharge={getChargeIcon}
          onGps={getGpsIcon}
          onLine={getOnlineIcon}
          onLock={getLockIcon}
          showPositionFromMap={handleOpen}
          getSpeed={value => (value ? (value.speed || 0) : null)}
          selectedId={selected}
        />
      </div>

    </div>
  );
};

const mapStateToProps = state => ({
  list: state.scooter.list.content,
  parkingList: state.scooterParking.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getList, dispatch),
  getParkingList: bindActionCreators(getParkingList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ScooterHotMap);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/scooter/hot-map/index.js